import { useRuntimeConfig } from "#app";

export const useIntercomHelp = () => {
  const intercomHelpActive = ref(false);
  const config = useRuntimeConfig();

  const toggleIntercomHelp = () => {
    if (import.meta.client && window.Intercom && config.public.IS_PROD) {
      if (intercomHelpActive.value) {
        window.Intercom("hide");
        intercomHelpActive.value = false;
      } else {
        intercomHelpActive.value = true;
        window.Intercom("show");
      }
    } else {
      // eslint-disable-next-line no-console
      console.error("Intercom not available to show/hide");
    }
  };

  return { toggleIntercomHelp };
};
